<button
  [disabled]="disabled"
  [ngClass]="cssClass + (isLoading ? ' in-progress ' : '')"
  [class.has-arrow]="showArrow"
  mat-flat-button
  class="loading-button button"
  [disableRipple]="disableRipple"
  [attr.data-cy]="dataCy"
  (click)="clickHandler($event)">

  <div class="content">
    <ng-content></ng-content>
    @if (showArrow && !disabled) {
      <div class="primary-text next-question-icon"></div>
    }

    @if (enableProgressIndicator) {
      <div class="button-progress-indicator primary-background-gray" [style.width.%]="100 - progress"></div>
    }
  </div>

  <div class="loading-indicator-wrapper">
    <mat-spinner color="white" [diameter]="20"></mat-spinner>
  </div>
</button>
